export default __webpack_public_path__ + "static/media/wongart-9.f7a56717.jpg";